export default {
  title: 'Cuéntanos,',
  subtitle: '¿por qué te interesa?',
  innovation: 'Innovación',
  thematic: 'Temática',
  author: 'Autor',
  messageLabel: '¿Quieres dejarnos un mensaje?',
  messagePlaceholder: 'Escribe aquí tu mensaje...',
  send: 'Enviar',
  thanks: '¡Gracias por tu interés!',
  contact: 'Te contactaremos a la brevedad para contarte más acerca de este Programa Educativo.'
}

export const en = {
  title: 'Tell us,',
  subtitle: 'why are you interested?',
  innovation: 'Innovation',
  thematic: 'Topic',
  author: 'Author',
  messageLabel: 'Want to leave a message?',
  messagePlaceholder: 'Write your message here...',
  send: 'Send',
  thanks: 'Thank you for your interest!',
  contact: 'We\'ll reach you soon to tell you more about this Educational Program.'
}

export const ca = {
  title: 'Digues,',
  subtitle: 'per quin motiu t\'interessa?',
  innovation: 'Innovació',
  thematic: 'Temàtica',
  author: 'Autor',
  messageLabel: 'Vols deixar-nos un missatge?',
  messagePlaceholder: 'Escriu el teu missatge aquí...',
  send: 'Envia',
  thanks: 'Gràcies pel teu interès!',
  contact: 'Contactarem amb tu ben aviat per explicar-te més sobre aquest Programa Educatiu.'
}
